import { BASE_API_ROUTES } from "../../constants/apis.constants";
import httpUtils from "../../Utils/http.utils";
import userUtils from "../../Utils/user.utils";
import useBaseActions from "./base.actions";

const useSettingsActions = () => {
  const { sendRequest } = useBaseActions();

  const updateEmailPhone = ({
    email, phone
  }) => {
    const formData = httpUtils.toFormData({
      accessKey: userUtils.getUserMessage(),
      ...(email && { Email: email }),
      ...(phone && { PhoneNumber: phone }),
    });
    const path = `${BASE_API_ROUTES.updatePhoneEmailInSettings}`;
    return sendRequest(path, 'POST', formData);
  }

  return {
    updateEmailPhone
  }
}

export default useSettingsActions;
